import React from 'react';
import { Box, Skeleton } from '@mui/material';

const rowSx = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '12px',
  padding: '12px 0',
  borderLeft: '3px solid transparent',
};

/**
 * Single row matching NotificationItem (icon circle + title + body lines).
 */
export function NotificationSkeletonRow() {
  return (
    <Box sx={rowSx}>
      <Skeleton
        variant="circular"
        width={24}
        height={24}
        animation="wave"
        sx={{
          flexShrink: 0,
          bgcolor: '#E8ECEF',
          border: '1px solid #E8ECEF',
        }}
      />
      <Box sx={{ flex: 1, minWidth: 0, pt: '2px' }}>
        <Skeleton
          variant="rounded"
          height={14}
          width="72%"
          animation="wave"
          sx={{ borderRadius: '4px', bgcolor: '#E8ECEF' }}
        />
        <Skeleton
          variant="rounded"
          height={14}
          width="92%"
          animation="wave"
          sx={{ borderRadius: '4px', mt: '6px', bgcolor: '#E8ECEF' }}
        />
      </Box>
    </Box>
  );
}

/** Section label + divider + rows (mimics "new / today" blocks). */
function NotificationSectionSkeleton({ rows = 2 }) {
  return (
    <Box sx={{ padding: '0 16px' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '16px 0 12px 0',
        }}
      >
        <Skeleton
          variant="rounded"
          width={56}
          height={10}
          animation="wave"
          sx={{ borderRadius: '2px', bgcolor: '#E8ECEF' }}
        />
        <Skeleton
          variant="rounded"
          height={1}
          sx={{ flex: 1, bgcolor: '#E8ECEF' }}
        />
      </Box>
      {Array.from({ length: rows }).map((_, i) => (
        <NotificationSkeletonRow key={i} />
      ))}
    </Box>
  );
}

/**
 * Initial load: mimics section + list (adjust `rows` for density).
 */
export function NotificationSkeletonList({ rows = 7 }) {
  return (
    <Box sx={{ pt: '16px' }}>
      <NotificationSectionSkeleton rows={rows} />
    </Box>
  );
}

/** Compact rows for pagination / load-more at bottom. */
export function NotificationSkeletonLoadMore({ rows = 2 }) {
  return (
    <Box sx={{ padding: '0 16px 8px 16px' }}>
      {Array.from({ length: rows }).map((_, i) => (
        <NotificationSkeletonRow key={i} />
      ))}
    </Box>
  );
}
